import { get } from './request'
export let loadCertificateForEnv = (envId, success, failure) => get(`/api/environment/${envId}/tls-certificate`, success, failure)